import Checkboxes from '../checkboxes/checkboxes';
import CheckboxesText from '../checkboxes-text/checkboxes-text';
import debounce from 'lodash/debounce';
import RangeInput from '../range-input/range-input';
import {SelectSection} from '../select-section/select-section';

interface TCallbackArgs {
    data: any;
    action: string;
}

interface TOptions {
    onChange?(args: TCallbackArgs): void;
    onInit?(args: TCallbackArgs & { keys: Record<string, any>}): void;
}

class ElectorFilter {
    private readonly parent: HTMLElement;
    private readonly selectors: Record<string, string>;

    constructor(parent: HTMLElement, options?: TOptions) {
        if (!parent) {
            console.warn(`Parent is ${parent}`);

            return;
        }

        this.parent = parent;
        const parentSelector = 'elector-filter';

        this.selectors = {
            filterShow: `${parentSelector}--is-show`,
            btnClose  : `${parentSelector}__btn-close`,
            btnShow   : `${parentSelector}__btn-show`
        };
        const formEl: HTMLFormElement | null = parent.querySelector('.elector-filter__fields');
        const resetBtn = parent.querySelector('.elector-filter__btn-reset');
        const btnCloseEl = parent.querySelector(`.${this.selectors['btnClose']}`);
        const btnShow = parent.querySelector(`.${this.selectors['btnShow']}`);

        const fieldKeys = new Set([].slice
            .call(formEl?.querySelectorAll('input[name], [data-field-name]'))
            .map((node: HTMLInputElement) => {
                if (node.hasAttribute('data-field-name')) {
                    return node.getAttribute('data-field-name');
                }

                return node.name;
            }));

        if (!formEl?.action) {
            console.warn(`Parent is ${formEl}`);

            return;
        }

        const requestData = {};

        if (formEl) {
            formEl.addEventListener('submit', (ev) => {
                ev.preventDefault();
            });
        }

        const updateRequestData = (name: string, values: any): void => {
            if (Array.isArray(values)) {
                if (values.length === 0) {
                    if (name in requestData) {
                        delete requestData[name];
                    }
                } else {
                    requestData[name] = values;
                }
            } else {
                requestData[name] = values;
            }
        };

        const sendByChangeData = ({name, values}: { name: string, values: any }): void => {
            updateRequestData(name, values);
            if (options?.onChange) {
                options.onChange({data  : requestData,
                    action: formEl.action});
            }
        };

        const sendByInitData = ({name, values}: { name: string, values: any }): void => {
            updateRequestData(name, values);
            if (options?.onInit) {
                options.onInit({
                    data  : requestData,
                    action: formEl.action,
                    keys  : [...fieldKeys]
                });
            }
        };

        const instansCheckboxes = [].slice.call(parent.querySelectorAll('.checkboxes')).map((el) => {
            return new Checkboxes(el, {
                onChange: sendByChangeData,
                onInit  : sendByInitData
            });
        });

        const instansRanges = [].slice.call(parent.querySelectorAll('.elector-filter__range')).map((el) => {
            return new RangeInput(el, {
                onChange: sendByChangeData,
                onInit  : sendByInitData
            });
        });

        const instansCheckboxesText = [].slice.call(parent.querySelectorAll('.checkboxes-text')).map((el) => {
            return new CheckboxesText(el, {
                onChange: sendByChangeData,
                onInit  : sendByInitData
            });
        });

        const instansSelectAreas = [].slice.call(parent.querySelectorAll('.select-section')).map((el) => {
            return new SelectSection(el, {
                onChange: sendByChangeData,
                onInit  : sendByInitData
            });
        });

        if (resetBtn) {
            resetBtn.addEventListener('click', debounce(() => {
                instansSelectAreas.forEach((inst) => {
                    inst.reset();
                });
                instansCheckboxes.forEach((inst) => {
                    inst.reset();
                });
                instansCheckboxesText.forEach((inst) => {
                    inst.reset();
                });
                instansRanges.forEach((inst) => {
                    inst.reset();
                });
            }, 300));
        }

        const hideFilter = (): void => {
            // @ts-ignore
            this.parent.classList.remove(this.selectors['filterShow']);
        };

        if (btnCloseEl) {
            btnCloseEl.addEventListener('click', hideFilter);
        }

        if (btnShow) {
            btnShow.addEventListener('click', hideFilter);
        }
    }

    showFilter = (): void => {
        if (this.parent) {
            // @ts-ignore
            this.parent.classList.add(this.selectors['filterShow']);
        }
    };
}

export default ElectorFilter;
